var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents contents_sp_headersmall"},[_vm._v(" 読み込み中です ")])}
var staticRenderFns = []

export { render, staticRenderFns }